class StrategyManager {

    static strategyMapper = {};
    static strategyParameters = {};

    static registerStrategy(strategyName, strategyFunction) {
        this.strategyMapper[strategyName] = strategyFunction;
    }

    static hasStrategy(strategyName) {      
        return (strategyName in this.strategyMapper);
    }
    static getStrategyHandler(strategyName) {
        if (!(strategyName in this.strategyMapper)) {
            throw `${strategyName} has not been registered with the StrategyManager`
        }
        return this.strategyMapper[strategyName];
    }

    static setParameters(strategyName, parameters) {
        this.strategyParameters[strategyName] = parameters;
    }

    static getParameters(strategyName) {
        if (!(strategyName in this.strategyParameters)) {
            throw `${strategyName}'s parameters has not been registered with the StrategyManager`
        }
        return this.strategyParameters[strategyName];
    }

}

module.exports = { StrategyManager };
